import { useEffect, useState } from "react";
import { callGetLottosByStatusNoPageable, callDownloadExcelTicketMovements } from "../../../../services/lottoService";
import { showNotificationTopEnd } from "../../../../util/utils";
import { Alert, Button, Col, Divider, Flex, Popconfirm, Row, Select, Space, Typography } from "antd";
import { DeleteOutlined, DownloadOutlined } from "@ant-design/icons";

const { Title } = Typography;

export default function TicketMovements() {
    const [lottoList, setLottoList] = useState([]);
    const [lotto, setLotto] = useState(null);
    const [loading, setLoading] = useState(false);


    useEffect(() => {
        getLottoList();
    }, []);


    const getLottoList = async () => {
        try {
            const response = await callGetLottosByStatusNoPageable({ status: ["ACTIVE", "CLOSED", "COMPLETED"] });
            if (response?.status === 200) {
                setLottoList(response.data);
            }
        } catch (err) {
            showNotificationTopEnd("error", "Error cargando sorteos");
        }
    };


    const handleDownloadExcel = async (action) => {
        setLoading(true);
        const response = await callDownloadExcelTicketMovements(action, lotto?.lottoId);
        if (response?.status === 200) {
            showNotificationTopEnd("success", "Solicitud enviada exitosamente");
        } else {
            showNotificationTopEnd("error", "Error al generar el Excel, por favor recarga la pagina");
        }
        setLoading(false);
    };


    return <Flex vertical>
        <Row gutter={[16, 16]} justify="space-between" align="middle" style={{ marginBottom: 24 }}>
            <Col span="auto">
                <Title level={3}>Reporte de movimientos</Title>
            </Col>
        </Row>

        <Flex align="center">
            <Title style={{ marginTop: 10, minWidth: 100, fontWeight: "normal" }} level={5}>Selecciona el Sorteo</Title>
            <Select
                showSearch
                placeholder="Selecciona el sorteo"
                filterOption={false}
                style={{ width: "100%" }}
                size="large"
                listHeight={300}
                options={lottoList?.map(lotto => ({
                    value: lotto.lottoId,
                    label: `ID: ${lotto.lottoId} - #${lotto.lottoNumber} ${lotto.title} - ${lotto.status}`,
                }))}
                onChange={(value) => {
                    const selected = lottoList.find(l => l.lottoId === value);
                    setLotto(selected);
                }}
            />
        </Flex>

        <br />
        {lotto ? (
            <div style={{ padding: '20px', textAlign: 'center' }}>
                <Space>
                    <Button
                        type="primary"
                        size="large"
                        icon={<DownloadOutlined />}
                        onClick={() => handleDownloadExcel("download")}
                        loading={loading}
                    >
                        Descargar Reporte
                    </Button>
                    <Divider type="vertical" style={{ height: '40px', backgroundColor: '#d9d9d9' }} />
                    <Popconfirm
                        title="Eliminar Información en Base de Datos"
                        description="¿Estas seguro de eliminar la información en base de datos? Esto no se puede deshacer"
                        onConfirm={() => handleDownloadExcel("delete")}
                        //onCancel={cancel}
                        okText="Si"
                        cancelText="No"><Button
                            danger
                            type="primary"
                            size="large"
                            icon={<DeleteOutlined />}
                            loading={loading}
                        >
                            Eliminar Información en Base de Datos
                        </Button>
                    </Popconfirm>
                </Space>
            </div>
        ) : (
            <Alert message="Por favor selecciona un sorteo para comenzar a gestionar los movimientos." type="info" showIcon />
        )}
    </Flex>;
}